const SET_IS_MOBILE = 'gruhn/display/SET_IS_MOBILE';
const SET_HEADER_SHOWING = 'gruhn/display/SET_HEADER_SHOWING';

export interface DisplayState {
    isMobile: boolean;
    headerShowing: boolean;
}

export interface DisplayAction {
    type: string;
    boolVal: boolean;
}

const initialState: DisplayState = {
    headerShowing: true,
    isMobile: false
};

export default function (state: DisplayState = initialState, action: DisplayAction) {
    switch (action.type) {
        case SET_IS_MOBILE:
            return { ...state, isMobile: action.boolVal };
        case SET_HEADER_SHOWING:
            return { ...state, headerShowing: action.boolVal };
        default:
            return state;
    }
}

export const setIsMobile = (isMobile: boolean): DisplayAction => ({ type: SET_IS_MOBILE, boolVal: isMobile });
export const setHeaderShowing = (headerShowing: boolean) => ({ type: SET_HEADER_SHOWING, boolVal: headerShowing });



// WEBPACK FOOTER //
// ./src/redux/modules/display.ts